var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2209 14.4974C26.0648 -4.83246 15.8136 -4.83246 19.6574 14.4974C15.8136 -4.83246 6.34008 -0.907862 17.2883 15.4785C6.34308 -0.907862 -0.907862 6.34307 15.4785 17.2913C-0.907862 6.34307 -4.82947 15.8136 14.4974 19.6604C-4.83246 15.8166 -4.83246 26.0678 14.4974 22.2239C-4.83246 26.0678 -0.907862 35.5413 15.4785 24.5931C-0.907862 35.5413 6.34307 42.7922 17.2913 26.4058C6.34307 42.7922 15.8136 46.7138 19.6604 27.3869C15.8166 46.7168 26.0678 46.7168 22.2239 27.3869C26.0678 46.7168 35.5413 42.7922 24.5931 26.4058C35.5413 42.7922 42.7922 35.5413 26.4058 24.5931C42.7922 35.5413 46.7138 26.0708 27.3869 22.2239C46.7168 26.0678 46.7168 15.8166 27.3869 19.6604C46.7168 15.8166 42.7922 6.34307 26.4058 17.2913C42.7922 6.34307 35.5413 -0.907862 24.5931 15.4785C35.5413 -0.907862 26.0708 -4.82947 22.2239 14.4974H22.2209Z",
    fill: "#E21E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.38bf4aefbb43f6b19657438b80dc52c4.svg";
export { ForwardRef as ReactComponent };